import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import FooterContact from 'components/FooterContact';
import FooterNav from 'components/FooterNav';
import MyrbLogo from 'components/MyrbLogo';
import SocialIcons from 'components/SocialIcons';

import styles from './Footer.scss';// to import local scss fle

const Footer = () => (
  <div className={cn('row', styles.footerContainer)}>
    <div className={cn('col s12', styles.footerInBigScreen)}>
      <div className={cn('col s3', styles.footerLogo)}>
        <MyrbLogo />
      </div>
      <div className={cn('col s3', styles.footerNav)}>
        <FooterNav />
      </div>
      <div className={cn('col s6', styles.footerContact)}>
        <FooterContact />
      </div>
    </div>
    <div className={cn('row', styles.footerInSmallScreen)}>
      <div className={cn('row')}>
        <FooterContact />
      </div>
      <div className={cn('row', styles.footerBorderInSmall)}>
        <div className={cn('col s6')}>
          <MyrbLogo />
        </div>
        <div className={cn('col s6')}>
          <FooterNav />
        </div>
      </div>
    </div>
    <SocialIcons />
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js